import { useEffect } from 'react'
import { Page, Spinner, Banner, Text, BlockStack } from '@shopify/polaris'

interface AuthPageProps {
  message?: string
  redirectUrl?: string
}

export function AuthPage({ message = 'Authenticating...', redirectUrl }: AuthPageProps) {
  useEffect(() => {
    if (redirectUrl) {
      window.location.href = redirectUrl
    }
  }, [redirectUrl])

  return (
    <Page>
      <BlockStack gap="400" align="center">
        {redirectUrl ? (
          <Banner tone="info">
            <Text as="p">Redirecting to Shopify for authentication...</Text>
          </Banner>
        ) : (
          <>
            <Spinner accessibilityLabel="Authenticating" size="large" />
            <Text as="p" tone="subdued">{message}</Text>
          </>
        )}
      </BlockStack>
    </Page>
  )
}
